import React, { useState, useEffect } from 'react';
import DimpleDivider from '@tds/core-dimple-divider';
import InputGroup from '@tds/community-input-group';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from '@tds/community-modal';
import request, { apiHost, config as axiosConfig } from '../utils/request';
import FMSOWFilters from '../filters/fmSOWFilters';
import { ContentWrapper, Box } from '../design/css';
import Table from '../design/shared/table';
import { OrderListModel } from './models';
import { Search } from '../srtDashboard/css';
import EN from '../../EN.json';
import FR from '../../FR.json';
import ValidateLoader from '../UI/validateLoader';
import 'react-responsive-modal/styles.css';
import {
  getButton,
  getStatus,
  getStatusFiltersPayload  
} from './utils';
import MessageNotification from '../messageNotification';
import stringInterpolation from '../utils/stringInterpolation';
import { useLocaleContext } from '../context/LocaleContext';
import View from './components/view';
import { getOptions, ChannelModel } from '../orders/models';
import { fullyManagedSOWForm, orderStatus } from '../utils/constant';
import { getFormattedDate } from '../utils/utils';

const initialFilterState = {
  startDate: null,
  endDate: null,
  completedStartDate: null,
  completedEndDate: null,
  province: [],
  channelId: [],
  productId: [],
  status: [],
  submitter: []
};

const OrderFulfillmentDashboardFMSOW = ({ location: { search } }) => {
  let url = '';
  const local = useLocaleContext();
  const {
    dashboardSOW: {
      staticLabelsForFilters,
      FMLandingPage: { searchLabel, searchHint },
      confirmationDialog,
      noOrders,
      loadingMessage,
      confirm,
      cancel,
      proceedWithOrder,
      locked,
      continueLabel,
      continueAction,
      cancelAction,
      confirmationMessage,
      manage,
      successActionMessage,
      status,
      statuses,
      header
    }
  } = local === 'en-US' ? EN : FR;

  const userProfile = JSON.parse(localStorage.getItem('userProfile'));

  const { provinces } = userProfile;

  const history = useHistory();
  const { q } = queryString.parse(history.location.search);
  const [searchString, setSearchString] = useState(q);
  const [filterState, setFilterState] = useState(initialFilterState);
  const [filters, setFilters] = useState('');
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [data, setData] = useState();
  const [action, setAction] = useState();
  const [channels, setChannels] = useState(null);
  const [submitters, setSubmitters] = useState(null);
  const [isOrderUpdated, setOrderUpdated] = useState();
  const [message, setMessage] = useState('has been successfully updated');

  const OrderFulfillmentPage = localStorage.getItem('OrderFulfillmentPageFMSOW')
    ? localStorage.getItem('OrderFulfillmentPageFMSOW')
    : 1;

  const [orderFulfillmentPage, setOrderFulfillmentPage] = useState(
    OrderFulfillmentPage
  );

  const [tableHeaders, setTableHeaders] = useState(header);

  const { page } = queryString.parse(search);
  const pageSize = 50;

  const filterData = {
    statuses,
    provinces,
    channels,
    submitters
  };

  useEffect(() => {
    setTableHeaders(header);
  }, [local]);

  const updateFilters = (key, value) => {
    setFilterState({ ...filterState, [key]: value });
  };

  const resetFilters = () => {
    setOrderFulfillmentPage(1);
    setFilterState({
      ...initialFilterState
    });
    setFilters('');
    filterOrders(true);
  };

  const fetchOrders = () => {
    return request.get(
      `/orders?typeOfOrder=SOW&pageNumber=${orderFulfillmentPage ||
        1}&pageSize=${pageSize}&${url}&dashboard=orderFulfillment`
    );
  };
  const fetchData = () => {
    setLoading(true);
    fetchOrders().then(ordersResp => {
      const {
        data: { totalCount: ordersCount, results: orders }
      } = ordersResp;
      setData({
        orders,
        count: ordersCount
      });
      setLoading(false);
    });
  };

  const fetchFiltersData = async () => {
    return axios
      .get(`${apiHost}/get-wln-filters?${url}`, axiosConfig())
      .then(response => {
        setSubmitters(_.get(response, 'data.usersList', 0));
        setChannels(
          getOptions(_.get(response, 'data.channels', 0), ChannelModel)
        );
      })
      .catch();
  };

  const getRedirectUrl = (row, formName) => {
    let steps;
    if (
      (row.status === orderStatus.SendBacktoPreSalesEngineer) &
      (row.step > 3)
    ) {
      steps = 1;
    } else {
      steps = row.step;
    }
    history.push({
      pathname: `/${row.locale}/${row.categoryName}/${formName}`,
      search: `?orderId=${row.id}&step=${steps}&isEditing=true`
    });
    window.location.reload();
  };

  const getFilterPayload = () => {
    const payload = {
      ...filterState,
      submittedBy:
        filterState.submitter.length && filterState.submitter[0].value,
      province: filterState.province.map(row => row.value),
      channelId: filterState.channelId.map(row => row.value)
    };

    if (filterState.startDate)
      payload.startDate = getFormattedDate(filterState.startDate);
    if (filterState.endDate)
      payload.endDate = getFormattedDate(filterState.endDate);
    if (filterState.completedStartDate)
      payload.completedStartDate = getFormattedDate(
        filterState.completedStartDate
      );
    if (filterState.completedEndDate)
      payload.completedEndDate = getFormattedDate(filterState.completedEndDate);
    return payload;
  };

  const getFilterParams = payload => {
    let allFilterParamsArray = {};
    if (payload.province && payload.province.length) {
      allFilterParamsArray.province = payload.province.map((n, index) => n);
    }
    if (payload.channelId && payload.channelId.length) {
      allFilterParamsArray.channelId = payload.channelId.map((n, index) => n);
    }
    if (payload.productId && payload.productId.length) {
      allFilterParamsArray.product = payload.productId.flatMap(
        (n, index) => n.value
      );
    }
    if (payload.status && payload.status.length) {
      const { status } = getStatusFiltersPayload(payload.status);
      if (status.length) allFilterParamsArray.status = status;
    }
    if (payload.channelOrgCode && payload.channelOrgCode.length) {
      allFilterParamsArray.channelOrgCode = payload.channelOrgCode.map(
        (n, index) => n.value
      );
    }
    if (payload.startDate) {
      allFilterParamsArray.startDate = payload.startDate;
    }
    if (payload.endDate) {
      allFilterParamsArray.endDate = payload.endDate;
    }
    if (payload.completedStartDate) {
      allFilterParamsArray.completedStartDate = payload.completedStartDate;
    }
    if (payload.completedEndDate) {
      allFilterParamsArray.completedEndDate = payload.completedEndDate;
    }
    if (payload.startDate || payload.endDate) {
      allFilterParamsArray.filterCriteria = 'createdAt';
    }
    if (payload.submitter && payload.submitter.length) {
      allFilterParamsArray.submitter = payload.submitter.map(
        (n, index) => n.value
      );
    }
    return allFilterParamsArray;
  };

  const filterOrders = (isResetMode = false) => {
    if (isResetMode === true) {
      fetchData();
    } else {
      const payload = getFilterPayload();
      setLoading(true);
      const allFilterParamsArray = getFilterParams(payload);
      setFilters(allFilterParamsArray);
      axios
        .post(
          `${apiHost}/orders/filter?typeOfOrder=SOW&pageNumber=${orderFulfillmentPage}&pageSize=${pageSize}&${url}&dashboard=orderFulfillment`,
          { ...allFilterParamsArray },
          { ...axiosConfig() }
        )
        .then(response => {
          const {
            data: { totalCount: ordersCount, results: orders }
          } = response;
          setData({
            orders,
            count: ordersCount
          });
          setLoading(false);
        })
        .catch(() => {});
    }
  };

  const applyFilters = () => {
    setOrderFulfillmentPage(1);
    localStorage.setItem('OrderFulfillmentPageFMSOW', 1);
    filterOrders();
  };

  const cancelOrder = () => {
    request
      .put(`/orders/${order.id}`, { status: 'ORDER_CANCELED' })
      .then(() => {
        setOrder({ ...order, open: false, isUpdated: true });
        fetchData();
      });
  };

  const onSave = value => {
    setMessage('has been successfully updated');
    window.scrollTo(0, 0);
    setOrderUpdated(value);
  };

  const actionContinue = row => {
    setAction(continueAction);
    setOrder({ open: true, orderDetails: row });
  };

  const actionCancel = (id, orderId) => {
    setAction(cancelAction);
    setOrder({ open: true, id, orderId });
  };

  const actionProceed = row => {
    setAction(proceedWithOrder);
    setOrder({ open: true, orderDetails: row });
  };

  const onConfirm = () => {
    switch (action) {
      case continueAction:
        getRedirectUrl(order.orderDetails, fullyManagedSOWForm);
        break;
      case cancelAction:
        cancelOrder();
        break;
      default:
    }
  };
  const getActions = row => {
    const { status: orderStatus } = row;
    const finalStatus = getStatus(orderStatus);

    const incompleteStatus = finalStatus === status.orderIncomplete;
    const pendingValidation = finalStatus === status.pendingValidation;
    const contractSent = finalStatus === status.contractSent;
    const contractSigned = finalStatus === status.contractSigned;
    const orderCompleted = finalStatus === status.orderCompleted;
    const canceledStatus = finalStatus === status.orderCanceled;
    const sendtoAccountManager = finalStatus === status.sendBacktoAccountManager;
    const sendBacktoSalesRep = finalStatus === status.sendBacktoSalesRep;

    let actions;
    if (incompleteStatus) {
      actions = (
        <>
          {getButton(() => actionContinue(row), continueLabel)}
          {getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (pendingValidation || sendtoAccountManager) {
      const orderData = row;
      actions = (
        <>
          <View orderData={orderData} onSave={onSave} fetchData={fetchData} />
          {getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (
      contractSigned ||
      orderCompleted ||
      contractSent ||
      sendBacktoSalesRep
    ) {
      const orderData = row;
      actions = (
        <View orderData={orderData} onSave={onSave} fetchData={fetchData} />
      );
    } else if (canceledStatus) {
      actions = <>{getButton(() => actionProceed(row), locked, true)}</>;
    }
    return actions;
  };
  const onSearchClick = () => {
    setOrderFulfillmentPage(1);
    localStorage.setItem('OrderFulfillmentPageFMSOW', 1);
    history.push({
      search: `?q=${searchString}`
    });
  };

  const onClear = () => {
    setOrderFulfillmentPage(1);
    localStorage.setItem('OrderFulfillmentPageFMSOW', 1);
    setSearchString('');
    history.push({
      search: ''
    });
  };

  useEffect(() => {
    (async () => {
      await fetchFiltersData();
    })();
    if (searchString) {
      url = `q=${searchString}`;
    } else {
      url = filters; // findAll=0 (for MY Orders) & findAll=1 (for All Orders)
    }
  }, []);

  useEffect(() => {
    if (searchString) {
      url = `q=${searchString}`;
      setOrderFulfillmentPage(1);
      localStorage.setItem('OrderFulfillmentPageFMSOW', 1);
      fetchData();
    } else if (filters) {
      filterOrders();
    } else {
      fetchData();
    }
  }, [page, orderFulfillmentPage, searchString]);
  return (
    <>
      <DimpleDivider />
      <div style={{ padding: '0 6rem' }}>
        <FMSOWFilters
          updateFilters={(key, value) => updateFilters(key, value)}
          filterState={filterState}
          onApplyFilters={applyFilters}
          onResetFilters={resetFilters}
          data={filterData}
          staticLabels={staticLabelsForFilters}
          isMyOrder={false}
        />
        <Search>
          <div></div>
          <InputGroup
            label={searchLabel}
            hint={searchHint}
            style={{ marginLeft: 20 }}
            defaultValue={searchString}
            onClearButtonClick={() => onClear()}
            onChange={e => setSearchString(e.target.value)}
            onButtonClick={() => onSearchClick()}
            onKeyDown={e => e.key === 'Enter' && onSearchClick()}
          />
        </Search>
      </div>
      <DimpleDivider />
      {isOrderUpdated && isOrderUpdated.isUpdated && (
        <Box pt={20} pb={20}>
          <MessageNotification
            variant="success"
            message={`${'Order with Order ID:'}${
              isOrderUpdated.orderId
            } ${message}`}
          />
        </Box>
      )}
      <ContentWrapper>
        {loading ? (
          <ValidateLoader message={loadingMessage} />
        ) : (
          <>
            {order && order.isUpdated && (
              <Box pt={20} pb={20}>
                <MessageNotification
                  variant="success"
                  message={stringInterpolation(
                    successActionMessage,
                    action,
                    order.orderId
                  )}
                />
              </Box>
            )}
            {data && data.orders && data.orders.length ? (
              <>
                <Table
                  style={{ backgroundColor: 'lime', color: 'black' }}
                  title={manage}
                  header={tableHeaders}
                  data={data.orders}
                  actions={getActions}
                  dataModel={OrderListModel}
                  currentPage={parseInt(orderFulfillmentPage || 1, 10)}
                  setOrderFulfillmentPage={setOrderFulfillmentPage}
                  count={data.count}
                  actionsDisplay="grid"
                  step={pageSize}
                />
              </>
            ) : (
              <p style={{ textAlign: 'center' }}>{noOrders}</p>
            )}
          </>
        )}

        {
          <Modal
            heading={confirmationDialog}
            bodyText={`${confirmationMessage} ${action} ?`}
            confirmCTAText={confirm}
            cancelButtonType="button"
            cancelCTAText={cancel}
            onConfirm={() => onConfirm()}
            onClose={() => setOrder({ ...order, open: false })}
            isOpen={action && order.open}
          />
        }
      </ContentWrapper>
    </>
  );
};

OrderFulfillmentDashboardFMSOW.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default OrderFulfillmentDashboardFMSOW;
